import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import CategoryManagement from "../CategoryManagement";
import { categoryService } from "../../api/services";

export default function CategoryManagementSection() {
  const [categories, setCategories] = useState([]);

  const fetchCategories = () => {
    categoryService.getCategories().then((res) => setCategories(res.data));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <CategoryManagement
        categories={categories}
        onCategoriesUpdate={fetchCategories}
      />
    </Container>
  );
}
